export default __webpack_public_path__ + "static/media/left-arrow.9ad652c4.svg";